import { ParamsDataPostCreateQuote, ParamsDataGetStatus, ParamsProductServiceAdd, itemProduct, ParamsFormOfPaymentServiceAdd, formOfPayment } from 'utils/typeServices';

const handleParseItens = (bodyItens: Array<itemProduct>) => {
    const dataItens: Array<ParamsProductServiceAdd> = bodyItens.map((value) => {
        return {
            CD_COTACAO_ITEM: parseFloat(value.cD_COTACAO_ITEM),
            VL_TOTAL: value.vL_TOTAL,
            VL_ITURAN: 0,
            VL_BRUTO_TOTAL: 0,
            VL_DESCONTO: 0,
            VL_MIN_CAMPANHA: 0,
            VL_ANUAL: value.vL_ANUAL,
            VL_BASE_COMISSAO: value.vL_BASE_COMISSAO,
            NR_MESES_RECORRENCIA: value.nR_MESES_RECORRENCIA,
            NM_PRODUTO: value.nM_PRODUTO,
            DS_PRODUTO: value.dS_PRODUTO,
            CD_PRODUTO: value.cD_PRODUTO,
            NR_PORCENTAGEM_INDENIZACAO: value.nR_PORCENTAGEM_INDENIZACAO,
            FL_ESCOLHIDO: value.fL_ESCOLHIDO,
            NR_TIPO_PRODUTO: value.nR_TIPO_PRODUTO,
            NR_ORDENACAO: value.nR_ORDENACAO,
            VL_COMISSAO_MINIMO: value.vL_COMISSAO_MINIMO,
            VL_COMISSAO_MAXIMO: value.vL_COMISSAO_MAXIMO,
            VL_COMISSAO_ADICIONAL: value.vL_COMISSAO_ADICIONAL,
            VL_FRANQUIA: value.vL_FRANQUIA,
            FL_OCS: value.fL_OCS,
            FL_CASCO: value.fL_CASCO,
            TAXA_VL_TOTAL: value.taxA_VL_TOTAL,
            TAXA_MSG: value.taxA_MSG,
            PRIMEIRA_MENSALIDADE_MSG: value.primeirA_MENSALIDADE_MSG,
            TIPO_COBRANCAS: [],
            FL_DOMICILIAR: value.fL_DOMICILIAR,
            FL_CHAVE_PRESENCA: false,
            NR_PESO_ESCOLHA: value.nR_PESO_ESCOLHA,
            CAMPANHAS_ELETIVAS_COTACAO_ITEM: [],
        }
    });

    return dataItens;
}

const handleParsePayment = (bodyPayment: Array<formOfPayment>) => {
    const dataPayment: Array<ParamsFormOfPaymentServiceAdd> = bodyPayment.map((value) => {
        return {
            CD_TIPO_COBRANCA: value.cD_TIPO_COBRANCA,
            CD_TIPO_FORMA_PAGAMENTO: value.cD_TIPO_FORMA_PAGAMENTO,
            FL_PERMITIR_DESCONTO: value.fL_PERMITIR_DESCONTO,
            FORMA_PAGAMENTO: value.formA_PAGAMENTO.map(({ cD_FORMA_PAGAMENTO, nM_FORMA_PAGAMENTO, nR_QTDE_PARCELAS_MAX }) => {
                return {
                    CD_FORMA_PAGAMENTO: cD_FORMA_PAGAMENTO,
                    NM_FORMA_PAGAMENTO: nM_FORMA_PAGAMENTO,
                    NR_QTDE_PARCELAS_MAX: nR_QTDE_PARCELAS_MAX
                }
            }),
            NM_TIPO_FORMA_PAGAMENTO: value.nM_TIPO_FORMA_PAGAMENTO,
            NR_MESES_RECORRENCIA: value.nR_MESES_RECORRENCIA,
            NR_PORCENTAGEM_DESCONTO: value.nR_PORCENTAGEM_DESCONTO
        }
    });

    return dataPayment;
}

export const ParseDataListQuoteAdd = (body: ParamsDataGetStatus) => {
    const dataListQuoteAdd: ParamsDataPostCreateQuote = {
        CD_PEDIDO_NOVO: body.cD_PEDIDO_NOVO,
        DESCONTO_2_PEDIDO: [],
        NM_LEAD: body.quote.nM_LEAD,
        CD_LEAD: body.quote.cD_LEAD,
        DS_PLACA: body.quote.dS_PLACA,
        DS_CHASSI: body.quote.dS_CHASSI,
        NR_CPF_CNPJ: body.quote.nR_CPF_CNPJ,
        CD_COTACAO: body.quote.cD_COTACAO,
        GUID_COTACAO: body.quote.guiD_COTACAO,
        DT_COTACAO: body.quote.dT_COTACAO,
        DT_VALIDADE: body.quote.dT_VALIDADE,
        COTACAO_ITEMS: handleParseItens(body.quote.cotacaO_ITEMS),
        NR_CEP_PERNOITE: body.quote.nR_CEP_PERNOITE,
        CD_PESSOA_PARCEIRO: body.quote.cD_PESSOA_PARCEIRO,
        CD_PESSOA_PARCEIRO_ESTABELECIMENTO: body.quote.cD_PESSOA_PARCEIRO_ESTABELECIMENTO,
        CD_PESSOA_VENDEDOR: body.quote.cD_PESSOA_VENDEDOR,
        CD_PESSOA_RESPONSAVEL: body.quote.cD_PESSOA_RESPONSAVEL,
        CD_CANAL_VENDA: body.quote.cD_CANAL_VENDA,
        CD_TIPO_COMERCIALIZACAO: body.quote.cD_TIPO_COMERCIALIZACAO,
        NR_ANO: body.quote.nR_ANO,
        NR_ANO_FABRICACAO: body.quote.nR_ANO_FABRICACAO,
        PORCENTAGEM_IMPOSTO: body.quote.porcentageM_IMPOSTO,
        FL_COMISSAO_VARIAVEL: body.quote.fL_COMISSAO_VARIAVEL,
        CD_MARCA: body.quote.cD_MARCA,
        NM_MARCA: body.quote.nM_MARCA,
        CD_MODELO_BASICO: body.quote.cD_MODELO_BASICO,
        NM_MODELO_BASICO: body.quote.nM_MODELO_BASICO,
        CD_MODELO: body.quote.cD_MODELO,
        NM_MODELO: body.quote.nM_MODELO,
        FL_INSTALADO: body.quote.fL_INSTALADO,
        FORMAS_PAGAMENTO: handleParsePayment(body.quote.formaS_PAGAMENTO),
        Allow_Sale: body.quote.allow_Sale,
        NR_TIPO_COTACAO: body.quote.nR_TIPO_COTACAO,
        QUOTE_URL: body.quote.quotE_URL,
        STATUS_PEDIDO_COTACAO: 0,
    };

    return dataListQuoteAdd;
}
